<template lang="pug">
  div
    v-app-bar(color="white" flat)
      v-toolbar-title.white--text
        div
          v-img(:src=" logo ? logo.file : require('@/assets/images/logo_main.png')" height="40px" style="max-width:120px" :contain="!logo")

</template>

<script>
export default {
  name: 'HeadBar',
  props: ['logo']
}
</script>